import { BaseError } from '@adornis/validation/errors/BaseError.js';

export class UserNotFoundError extends BaseError {
  static override _class = 'UserNotFoundError';

  public constructor() {
    super('UserNotFoundError', { translationKey: 'user-not-found-error' });
  }
}
